export default __webpack_public_path__ + "static/media/icon_envelope_bleu.f7fefc68.svg";